import React from "react";
import "./SectionAdd.css";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import { Col } from "react-bootstrap";

const SectionAdd = () => {
  return (
    <div className="about-area_home">
      <div className="default-width my-4">
        <div className="row">
          <div className="col-lg-6 col-md-12 align-items-center">
            <div className="about-image">
              <img
                alt="Doctors Image"
                loading="lazy"
                width={500}
                height={400}
                decoding="async"
                data-nimg={1}
                src="/Images/backgrr.png"
                style={{ color: "transparent" }}
                className="section_add_image"
              />
            </div>
          </div>
          <Col className="">
            <div className="wpb_wrapper_section-add">
              <div
                className="about_us_second_home_wrapper"
                id="tm-heading-678bfaf9e1d55"
              >
                <h3 className="headingss">Why Surgery Saathi?</h3>
              </div>
              <div className="tm-spacer" id="tm-spacer-678bfaf9e21d0" />
              <div
                className="about_us_second_home_wrapper"
                id="tm-heading-678bfaf9e22d6"
              >
                <h3 className="heading">
                  We take care of all aspects of surgery so you don’t have to.
                </h3>
              </div>
              <ul className="about-list about-list_home_section mt-0">
                <li className="py-0 py-md- section_add_list_tags ">
                  <div>
                    <img
                      alt=""
                      fetchpriority="high"
                      width={20}
                      height={20}
                      src="https://cdn.hexahealth.com/static/images/user.svg"
                      style={{ color: "transparent", marginRight: "0.5rem" }}
                      className="section_add_innerima"
                    />
                  </div>
                  <div className="section_add_font_first">
                    Expert Surgeons with 10+ Years Experience
                  </div>
                </li>
                <li className="py-0 py-md- section_add_list_tags">
                  <div>
                    <img
                      alt=""
                      fetchpriority="high"
                      width={20}
                      height={20}
                      decoding="async"
                      data-nimg={1}
                      src="https://cdn.hexahealth.com/static/images/layers.svg"
                      style={{ color: "transparent", marginRight: "0.5rem" }}
                      className="section_add_innerima"
                    />
                  </div>
                  <div className="section_add_font_first">
                    Top JCI &amp; NABH Accredited Hospitals
                  </div>
                </li>
                <li className="py-0 py-md- section_add_list_tags">
                  <div>
                    <img
                      alt=""
                      fetchpriority="high"
                      width={20}
                      height={20}
                      decoding="async"
                      data-nimg={1}
                      src="https://cdn.hexahealth.com/static/images/headset.svg"
                      className="section_add_innerima"
                      style={{ color: "transparent", marginRight: "0.5rem" }}
                    />
                  </div>
                  <div className="section_add_font_first">
                    {" "}
                    Personal Care Assistance
                  </div>
                </li>
                <li className="py-0 py-md- section_add_list_tags">
                  <div>
                    <img
                      alt=""
                      fetchpriority="high"
                      width={20}
                      height={20}
                      decoding="async"
                      data-nimg={1}
                      src="https://cdn.hexahealth.com/static/images/check-circle.svg"
                      className="section_add_innerima"
                      style={{ color: "transparent", marginRight: "0.5rem" }}
                    />
                  </div>
                  <div className="section_add_font_first">
                    Insurance Approval &amp; Claim
                  </div>
                </li>
                <li className="py-0 py-md- section_add_list_tags">
                  <div>
                    <img
                      alt=""
                      fetchpriority="high"
                      width={20}
                      height={20}
                      decoding="async"
                      data-nimg={1}
                      src="https://cdn.hexahealth.com/static/images/check-circle.svg"
                      className="section_add_innerima"
                      style={{ color: "transparent", marginRight: "0.5rem" }}
                    />
                  </div>
                  <div className="section_add_font_first">No Cost EMI</div>
                </li>
                <li className="py-0 py-md- section_add_list_tags">
                  <div>
                    <img
                      alt=""
                      fetchpriority="high"
                      width={20}
                      height={20}
                      decoding="async"
                      data-nimg={1}
                      src="https://cdn.hexahealth.com/static/images/check-circle.svg"
                      className="section_add_innerima"
                      style={{ color: "transparent", marginRight: "0.5rem" }}
                    />
                  </div>
                  <div className="section_add_font_first">
                    Post Surgery Care
                  </div>
                </li>
              </ul>
            </div>
          </Col>
          {/* <div className="col-lg-6 col-md-12 order-0 order-md-1">
            <div className="about-content">
              <h2 className="m-0 m-md-2">Why HexaHealth?</h2>
              <p className="py-1 py-md-3">
                We take care of all aspects of surgery so you don’t have to.
              </p>
              <ul className="about-list mt-0">
                <li className="py-0 py-md-2">
                  <img
                    alt=""
                    fetchpriority="high"
                    width={20}
                    height={20}
                    decoding="async"
                    data-nimg={1}
                    src="https://cdn.hexahealth.com/static/images/user.svg"
                    style={{ color: "transparent", marginRight: "0.5rem" }}
                  />
                  Expert Surgeons with 10+ Years Experience
                </li>
                <li className="py-0 py-md-2">
                  <img
                    alt=""
                    fetchpriority="high"
                    width={20}
                    height={20}
                    decoding="async"
                    data-nimg={1}
                    src="https://cdn.hexahealth.com/static/images/layers.svg"
                    style={{ color: "transparent", marginRight: "0.5rem" }}
                  />
                  Top JCI &amp; NABH Accredited Hospitals
                </li>
                <li className="py-0 py-md-2">
                  <img
                    alt=""
                    fetchpriority="high"
                    width={20}
                    height={20}
                    decoding="async"
                    data-nimg={1}
                    src="https://cdn.hexahealth.com/static/images/headset.svg"
                    style={{ color: "transparent", marginRight: "0.5rem" }}
                  />
                  Personal Care Assistance
                </li>
                <li className="py-0 py-md-2">
                  <img
                    alt=""
                    fetchpriority="high"
                    width={20}
                    height={20}
                    decoding="async"
                    data-nimg={1}
                    src="https://cdn.hexahealth.com/static/images/check-circle.svg"
                    style={{ color: "transparent", marginRight: "0.5rem" }}
                  />
                  Insurance Approval &amp; Claim
                </li>
                <li className="py-0 py-md-2">
                  <img
                    alt=""
                    fetchpriority="high"
                    width={20}
                    height={20}
                    decoding="async"
                    data-nimg={1}
                    src="https://cdn.hexahealth.com/static/images/check-circle.svg"
                    style={{ color: "transparent", marginRight: "0.5rem" }}
                  />
                  No Cost EMI
                </li>
                <li className="py-0 py-md-2">
                  <img
                    alt=""
                    fetchpriority="high"
                    width={20}
                    height={20}
                    decoding="async"
                    data-nimg={1}
                    src="https://cdn.hexahealth.com/static/images/check-circle.svg"
                    style={{ color: "transparent", marginRight: "0.5rem" }}
                  />
                  Post Surgery Care
                </li>
              </ul>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default SectionAdd;
